export enum DropdownItemPosition {
    FIRST = "first",
    LAST = "last",
    MIDDLE = "middle",
}

export enum InputComponentTypes {
    TEXT = "text",
    NUMBER = "number",
    PERCENT = "percent",
}

export enum AdditionalInputComponentTypes {
    TEXT_AREA = "textArea",
}
